import axios from 'axios';
import {
  rootUrl,
  basketFloatDelay,
  basketFloatWidth,
  basketFloatzIndex
} from './config';
import lang_product_detail from '../../lang/webshop_product_detail.json';

function bindBasketEvents(){
  var ele=$("div.popup-basket");
  if(ele && ele.length) ele[0].style.display="none";
  $(".popup-basket").on("click", function(evt){
    evt.stopPropagation();
  });

  $(".popup-basket button.btn-clear").on("click", function(evt){
    evt.stopPropagation();
    clearBasket(this);
  });
  $("button[name='remove_basket_row']").on("click", function(evt){
    evt.stopPropagation();
    removeBasket($(this).data("pid"),this);
  });
  $("button[name='decrease_qty'],button[name='increase_qty']").on("click", function(evt){
    evt.stopPropagation();
    changeQty($(this).data("pid"),$(this).val(),this);
  });
  $("input[name='qty']").on("change", function(evt){
    evt.stopPropagation();
    changeQty($(this).data("pid"),$(this).val(),this);
  });
  $("input[name='qty']").on("click", function(evt){
    evt.stopPropagation();
  });
  //console.log("Binding...1")
  $('div.wex-mobile-basket div.header-basket-btn').off("click", basketToogleHandler);
  $('img.shopping-basket, div.basket-item-count').off("click", basketToogleHandler);
  $("button.basket-close-btn").on("click", basketToogleHandler);
  $('div.popup-basket div.arrow-up, img.shopping-basket, div.basket-item-count').on("click", basketToogleHandler);
  $('div.wex-mobile-basket div.header-basket-btn').on("click", basketToogleHandler);
  $('#header,#wex_wrap').on("click", function(evt){
    var ele=$("div.popup-basket");
    if(ele && ele.length){
      ele[0].style.display="none";
    }
  });
  //console.log("Binding...2")
}

function basketToogleHandler(evt){
  evt.stopPropagation();
  var ele=$("div.popup-basket");
  if(ele && ele.length){
    if(ele[0].style.display == "none"){
      var mobileMenu = $("div.mobile-menu-wrapper");
      if(mobileMenu && mobileMenu.length) mobileMenu[0].style.display="none";
      ele[0].style.display="block";
    } else { 
      ele[0].style.display="none";
      $.LoadingOverlay("hide",true);
    }
  }
}

function bindBasketToUI(data) {
  var scrollPos = $("div.basket-body").scrollTop();
  var basketCnt=$("div.popup-basket");
  var cssText=null;
  if(basketCnt && basketCnt.length) cssText=basketCnt[0].style.cssText;
  $("div.popup-basket").remove();
  if(data && data.html){
    $(data.html).insertAfter($("div.wex-mobile-basket"));
  }
  if(data && data.data){
    data.data.basket_count=isNaN(data.data.basket_count)?0:Number(data.data.basket_count);
    $("div.wex-mobile-basket div.basket-item-count").html(data.data.basket_count);
  }
  bindBasketEvents();
  basketCnt=$("div.popup-basket");
  if(basketCnt && basketCnt.length && cssText) basketCnt[0].style.cssText=cssText;
  $("div.basket-body").scrollTop(scrollPos);
}

function clearBasket(ele) {
  let url=`${rootUrl}/basket/clear`;
  axios({url:url,method:'POST'}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function removeBasket(pId, ele) {
  let url=`${rootUrl}/basket/remove`;
  axios({url:url,method:'POST',data:{product_id:pId}}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function changeQty(pId, qty, ele) {
  let url=`${rootUrl}/basket/qty`;
  qty = isNaN(qty)?0:Number(qty);
  if(qty <= 0) qty=1;
  axios({url:url,method:'POST',data:{product_id:pId, qty: qty}}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function getBasket(){
  let url=`${rootUrl}/basket/load`;
  axios({url:url,method:'GET'}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function add2basket(ele, pId, from){
    let url=`${rootUrl}/add2basket`;
    $(ele).addClass("adding-to-basket");
    axios({url:url,method:'POST',data:{product_id:pId,from:from}}).then(function(res) {
      $(ele).removeClass("adding-to-basket");
      bindBasketToUI(res.data);
      if(res.data && res.data.data)  basketChanged(pId,res.data.data.add2cart_txt);
    }).catch(function(err){
      $(ele).removeClass("adding-to-basket");
      console.log(err);
    });
    return true;
}

function add2basketfromproductpage(ele, pId, from){
  if(sessionStorage.getItem("isdoneselection") || $(ele).data("isdoneselection")){
  add2basket(ele, pId, from);
  return true;
  }
  $(".product-info .price-stock .ps-left .sku-info").addClass("warning-user");
  if(!$("#remind-customer-sku").length){
    $(".product-info .price-stock .ps-left .sku-info").append(
      `<div id="remind-customer-sku">${lang_product_detail.product_detail.remind_customer_selection}</div>`);
  }
}
function fvBindingEvents() {
  $("div.product-detail div.addcart img.fv-add").on("click",function(evt){
    evt.stopPropagation();
    add2fv(this,$(this).data("pid"));
  });
  $("div.product-detail div.addcart img.fv-remove").on("click",function(evt){
    evt.stopPropagation();
    removefromfv(this,$(this).data("pid"));
  });
  $("div.product-cell.fv-item button.close-btn").on("click",function(evt){
    evt.stopPropagation();
    removefromfv(this,$(this).data("pid"));
  });
}
function add2fv(ele, pId){
  let url=`${rootUrl}/product/wishlist`;
  axios({url:url,method:'POST',data:{pId:pId}}).then(function(res) {
    if(res.data && res.data.status){
      $(`.prod-fv-list`).closest(".product-list-container").remove();
      // $(res.data.html).insertBefore($(".wex-container .tp-slider.wh-widget"));
      $(ele).removeClass("fv-add").addClass("fv-remove");
      $(ele).attr("src",$(ele).data("img-fill"));
      $("div.product-detail div.addcart img.fv-remove").off("click");
      $("div.product-detail div.addcart img.fv-remove,div.product-cell.fv-item button.close-btn").on("click",function(evt){
        evt.stopPropagation();
        removefromfv(this,$(this).data("pid"));
      });
      if($(".product-list-container .prod-fv-list").get(0))
        $(".product-list-container .prod-fv-list").get(0).scrollIntoView(false);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function removefromfv(ele, pId){
  let url=`${rootUrl}/product/wishlist`;
  axios({url:url,method:'DELETE',data:{pId:pId}}).then(function(res) {
    if(res.data && res.data.status){
      $(`.prod-fv-list .product_result_container .product-cell.fv-item.prodid-${pId}`).remove();
      if($(ele).hasClass("fv-remove")){
        $(ele).removeClass("fv-remove").addClass("fv-add");
        $(ele).attr("src",$(ele).data("img-nofill"));
        $("div.product-detail div.addcart img.fv-add").off("click");
        $("div.product-detail div.addcart img.fv-add").on("click",function(evt){
          evt.stopPropagation();
          add2fv(this,$(this).data("pid"));
        });
      }
      if($(`.prod-fv-list .product_result_container .product-cell.fv-item`).length <= 0) {
        $(`.prod-fv-list`).closest(".product-list-container").remove();
      }
      if($(".product-list-container .prod-fv-list").get(0))
        $(".product-list-container .prod-fv-list").get(0).scrollIntoView(false);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function basketChanged(product_id, txt){
  var m_left=Number($(".wex-mobile-basket").offset().left+$(".wex-mobile-basket").width()-basketFloatWidth);
  var m_top = Number($("#header").height());
  $(".notifications.top-right").css({"top":`${m_top}px`,"z-index":`${basketFloatzIndex}`,"left":`${m_left}px`});
  var selector = ".product.id-"+product_id;
  var added_row = $(selector)[0];
  added_row = $(added_row).clone();
  $(added_row).find('.price').remove();
  $(added_row).find('.action').remove();
  var pname = $(added_row).find(".b-info .name a").html();
  $(added_row).find(".b-info .name a").remove();
  $(added_row).find(".b-info .name").html(pname);
  $(added_row).find(".b-info").append("<div class='msg'>"+txt+"</div>");
  $('.notifications.top-right').notify({
    message: { html: $(added_row).html() },
    closable: false,
    fadeOut: { delay: basketFloatDelay},
    transition:"not-use",
    onClose: function() {
      if($(".notifications.top-right").children().length <= 0)
        $(".notifications.top-right").css({"top": "72px","z-index":"1"});
    }
  }).show();
}

export {add2basket, getBasket,fvBindingEvents, add2basketfromproductpage};